// Dependency-free helpers kept out of the large `@/utilities` and `@/constants`
// modules so they can be imported from `_app` without bloating the shared bundle.
// Both of those modules re-export these, so existing imports keep working.

export const classNames = (...classes) => classes.filter(Boolean).join(" ");

export const internalRoutes = [
    "/company/",
    "/engineer/",
    "/interviews",
    "/404",
    "/500",
    "/force-add-details",
    "/force-reset-password",
    "/forgot-password",
    "/login",
    "/signup",
    "/verify-email",
];

export const isPublicPage = (router) =>
    !internalRoutes.find((path) => router?.pathname.startsWith(path)) ||
    router?.pathname === "/";
